/** What a key in a combobox's text field does: highlight another suggestion, pick, close, or nothing. */
export type ComboboxAction = { move: number } | 'pick' | 'close' | null;

/**
 * `count` suggestions show, `active` is highlighted (-1: none). The arrows wrap
 * around; Enter picks only a highlighted one, so with none it keeps its usual
 * job (submitting the form); Escape closes the list when it can be closed.
 */
export function comboboxKey(
  key: string,
  active: number,
  count: number,
  closable: boolean
): ComboboxAction {
  if (!count) return null;
  const last = count - 1;
  if (key === 'ArrowDown') return { move: active >= last ? 0 : active + 1 };
  if (key === 'ArrowUp') return { move: active <= 0 ? last : active - 1 };
  if (key === 'Enter') return active >= 0 ? 'pick' : null;
  return key === 'Escape' && closable ? 'close' : null;
}
